import { useQuery } from '@tanstack/react-query';
import riskService from '../services/risk.service';
import { setSeverityBands } from '../lib/severity';

// The band ceilings are operator-editable on the backend, and every badge,
// dot and label on the register reads them synchronously, so they live in a
// module-level holder rather than a context. This primes that holder once the
// user is authenticated. Until it lands, and if it fails, the settings
// defaults apply.
export function useSeverityBands(enabled: boolean) {
  return useQuery({
    queryKey: ['severity-bands'],
    queryFn: async () => {
      const bands = await riskService.getSeverityBands();
      setSeverityBands(bands);
      return bands;
    },
    enabled,
    staleTime: 60 * 60_000,
    retry: false,
  });
}
